import { render, staticRenderFns } from "./draftDeclaration.vue?vue&type=template&id=d34d76ee&scoped=true"
import script from "./draftDeclaration.vue?vue&type=script&lang=js"
export * from "./draftDeclaration.vue?vue&type=script&lang=js"
import style0 from "./draftDeclaration.vue?vue&type=style&index=0&id=d34d76ee&prod&scoped=true&lang=css"
import style1 from "./draftDeclaration.vue?vue&type=style&index=1&id=d34d76ee&prod&lang=css"
import style2 from "./draftDeclaration.vue?vue&type=style&index=2&id=d34d76ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34d76ee",
  null
  
)

export default component.exports